import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import store from 'app/store';
import Root from 'app/Root';
import * as serviceWorker from 'serviceWorker';
import 'styles.scss';

ReactDOM.render(
  <Provider store={store}>
    {/* <React.StrictMode> */}
      <Root />
    {/* </React.StrictMode> */}
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
